import { api } from "./api";

export async function compressImage(file, max = 1600, quality = 0.75) {
  if (!file.type.startsWith("image/") || file.type === "image/gif") return file;
  const img = await new Promise((res, rej) => {
    const i = new Image();
    i.onload = () => res(i);
    i.onerror = rej;
    i.src = URL.createObjectURL(file);
  });
  const scale = Math.min(1, max / Math.max(img.width, img.height));
  const c = document.createElement("canvas");
  c.width = Math.round(img.width * scale);
  c.height = Math.round(img.height * scale);
  c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
  const blob = await new Promise((res) => c.toBlob(res, "image/jpeg", quality));
  return new File([blob], file.name.replace(/\.\w+$/, ".jpg"), { type: "image/jpeg" });
}

export async function uploadFile(file) {
  const f = await compressImage(file);
  const fd = new FormData();
  fd.append("file", f);
  const { data } = await api.post("/files", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}

export const fileUrl = (id) => `${process.env.REACT_APP_BACKEND_URL}/api/files/${id}`;
